// extracted by mini-css-extract-plugin
export var compactFilters = "_hm-4";
export var detailImage = "_hm-1";
export var dropdownContainer = "_hm-2";
export var imageContainer = "_hm-0";
export var selectedCard = "_hm-3";